import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("th_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("th_cookie_consent", "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("th_cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-in-bottom" data-testid="cookie-consent">
      <div className="max-w-4xl mx-auto bg-card rounded-2xl border border-border/50 shadow-xl p-5 space-y-3">
        <p className="text-sm text-foreground">
          We use local storage to save your therapy preferences and track your progress. No personal data is collected or shared with third parties.
        </p>
        <p className="text-xs text-muted-foreground">
          This site contains affiliate links. We may earn a commission from purchases made through these links at no additional cost to you. This helps support our free platform.
        </p>
        <div className="flex flex-wrap items-center gap-3">
          <Button size="sm" onClick={accept} data-testid="cookie-accept">Accept</Button>
          <Button variant="outline" size="sm" onClick={decline} data-testid="cookie-decline">Decline</Button>
          <a href="/privacy" className="text-xs text-primary hover:underline">Learn More</a>
        </div>
        <div className="flex gap-3 text-[10px] text-muted-foreground/60">
          <a href="/privacy" className="hover:underline">Privacy Policy</a>
          <span>&middot;</span>
          <a href="/terms" className="hover:underline">Terms of Service</a>
          <span>&middot;</span>
          <a href="/disclaimer" className="hover:underline">Affiliate Disclosure</a>
        </div>
      </div>
    </div>
  );
}
